/* This file is autogenerated, see readme.md for instructions */
import EditSvgIcon from '@bloomreach/banana-theme/icons/edit.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const EditIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <EditSvgIcon />
    </Icon>
  );
});

EditIcon.displayName = 'EditIcon';

export default EditIcon;
